import { useState } from 'react';
import { toast } from 'sonner';
import { Modal } from '@/components/kit';

/**
 * Record an advance (سلف) — money lent to a member of staff and taken back a
 * fixed amount a month off their payslip until it is cleared.
 */
export function AdvanceModal({
  open,
  who,
  onClose,
  onSave,
}: {
  open: boolean;
  who: string;
  onClose: () => void;
  onSave: (amountMinor: number, monthlyMinor: number, note?: string) => void;
}) {
  const [total, setTotal] = useState('');
  const [monthly, setMonthly] = useState('');
  const [note, setNote] = useState('');

  const submit = () => {
    const amountMinor = Math.round(Number(total) * 100);
    const monthlyMinor = Math.round(Number(monthly) * 100);
    if (!(amountMinor > 0) || !(monthlyMinor > 0)) {
      toast.info('Put in how much was lent and how much comes off each month.');
      return;
    }
    if (monthlyMinor > amountMinor) {
      toast.info('The monthly repayment cannot be more than the advance.');
      return;
    }
    onSave(amountMinor, monthlyMinor, note.trim() || undefined);
    setTotal('');
    setMonthly('');
    setNote('');
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Record an advance"
      sub={`${who} — repaid monthly off the payslip until it is cleared`}
      foot={
        <>
          <button type="button" className="btn btn-outline" onClick={onClose}>Not now</button>
          <button type="button" className="btn btn-primary" onClick={submit}>Record the advance</button>
        </>
      }
    >
      <div className="mt12">
        <label className="t-ovl mut" htmlFor="adv-total">Lent</label>
        <input id="adv-total" className="fld t-strong mt4 num" inputMode="decimal" placeholder="0.00" value={total} onChange={(e) => setTotal(e.target.value)} />
      </div>
      <div className="mt12">
        <label className="t-ovl mut" htmlFor="adv-monthly">Comes off each month</label>
        <input id="adv-monthly" className="fld t-strong mt4 num" inputMode="decimal" placeholder="0.00" value={monthly} onChange={(e) => setMonthly(e.target.value)} />
      </div>
      <div className="mt12">
        <label className="t-ovl mut" htmlFor="adv-note">Note</label>
        <input id="adv-note" className="fld mt4" placeholder="What it was for" value={note} onChange={(e) => setNote(e.target.value)} />
      </div>
    </Modal>
  );
}
